"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dsWeb = require("@olxbr/ds-web");
var _dsIcons = require("@olxbr/ds-icons");
var _propTypes = require("prop-types");
var _style = require("../../style");
var _actions = require("../../../../../actions");
var _selectors = require("../../../../../selectors");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var Rating = function Rating(_ref) {
  var rating = _ref.rating,
    clickRatingAction = _ref.clickRatingAction,
    currentUser = _ref.currentUser;
  var _useState = (0, _react.useState)(localStorage.getItem('userRatingSecurityTip')),
    _useState2 = _slicedToArray(_useState, 1),
    getRatingUser = _useState2[0];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    haveRated = _useState4[0],
    setHaveRated = _useState4[1];
  var handleClick = function handleClick(ratingType) {
    clickRatingAction(ratingType.type, ratingType.name, ratingType.detail, ratingType.data);
    var ratingUser = "".concat(ratingType.name, "|").concat(currentUser);
    localStorage.setItem('userRatingSecurityTip', ratingUser);
    setHaveRated(true);
  };
  if (getRatingUser || !rating) {
    return null;
  }
  if (haveRated) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.RatingBubble, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.RatedTitle, {
        children: '✔️ Agradecemos por nos ajudar :)'
      })]
    });
  }
  return !getRatingUser && rating && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.RatingBubble, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.RatingTitle, {
      children: "Essas informa\xE7\xF5es foram \xFAteis?"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.RatingButtons, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.ThumbsDown, {}),
        onClick: function onClick() {
          return handleClick(rating.analytics.negative, clickRatingAction, currentUser);
        },
        size: "small",
        variant: "neutral",
        children: "N\xE3o"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.ThumbsUp, {}),
        onClick: function onClick() {
          return handleClick(rating.analytics.positive, clickRatingAction, currentUser);
        },
        size: "small",
        variant: "neutral",
        children: "Sim"
      })]
    })]
  });
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    clickRatingAction: _actions.clickRating
  }, dispatch);
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: (0, _selectors.getCurrentUser)(state)
  };
};
Rating.propTypes = {
  rating: _propTypes.object,
  analytics: _propTypes.object.isRequired,
  clickRatingAction: _propTypes.func.isRequired
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps, mapDispatchToProps)(Rating);